import RosterEmptyStates from './RosterEmptyStates';

export default {
  ReactComponent: RosterEmptyStates,
  bindings: {
    buildSchedule: '&',
    clearFilters: '&',
    date: '<',
    showResetFilters: '<',
    hasShiftsWithinTwoWeeks: '<',
  },
};
